import React from "react";
import { MuiTelInput } from "mui-tel-input";
import { colors } from "../../Config/Colors";

export default function TelInput(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    disabled = false,
  } = props;

  return (
    <MuiTelInput
      disabled={disabled}
      variant="outlined"
      label={label || undefined}
      name={name}
      value={value}
      defaultCountry="TR"
      onChange={(value) => {
        const target = { name, value };
        const e = { target: target };
        onChange(e);
      }}
      {...(error && { error: true, helperText: error })}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
          borderRadius: "12px",
          "& fieldset": {
            borderColor: "#d1d5db",
            borderWidth: "1px",
          },
          "&:hover fieldset": {
            borderColor: "#9ca3af",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#6366f1",
            borderWidth: "2px",
          },
        },
        "& .MuiInputLabel-root": {
          color: "#6b7280",
          fontSize: "14px",
        },
        "& .MuiInputLabel-shrink": {
          backgroundColor: "#fff",
        },
      }}
    />
  );
}
